// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 251 ? "674a26a7" : chunkId) + "." + {"251":"60156f9325ba2163","919":"07c6b8536b715587"}[chunkId] + ".js";
};